import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import Body from "./components/Body";
import { appStore, persistor } from "./utils/appStore";
import { applyThemeColors } from "./components/Header";
import { useEffect } from "react";
import { safeJsonParse } from "./utils/utilityFunctions/stringUtility";
// import { SocketProvider } from "./components/UniversalComponents/SocketContext";
// import useOnlineStatus from "./hooks/useOnlineStatus";
// import OfflineModal from "./components/OfflineModal";
function App() {
  // const isOnline = useOnlineStatus();

  // Make it "TRUE" to hide all "console logs" from the app in browser.
  if (false) {
    for (let method of ["log", "warn", "error", "info", "debug"]) {
      console[method] = (...args) => {};
    }
  }

  useEffect(() => {
    const prefs = safeJsonParse(localStorage.getItem("userPreferences"));
    if (prefs?.theme_color) {
      applyThemeColors(prefs.theme_color);
    }
  }, []);

  return (
    <Provider store={appStore}>
      {/* ---------------- To Show the user OfflineModal when the user is offline -------------- */}
      {/* {!isOnline && <OfflineModal isOnline={isOnline} />} */}

      {/* <PersistGate loading={null} persistor={persistor}> */}
      {/* <SocketProvider> */}
      <Body />
      {/* </SocketProvider> */}
      {/* </PersistGate> */}
    </Provider>
  );
}

export default App;
